import { Fragment } from 'react/jsx-runtime';
import styles from './Breadcrumbs.module.scss';
import HomeIcon from './home.svg';

interface BreadcumbsProps {
  /**
   * 자식 요소로 BreadcrumbsItem 컴포넌트를 받습니다.
   * 각 BreadcrumbsItem은 경로를 나타내며, 클릭 시 해당 경로로 이동합니다.
   */
  children: React.ReactNode;
}

/**
 * Breadcrumbs 컴포넌트
 * 여러 개의 ```<BreadcrumbsItem />```을 자식으로 받아 경로를 표시합니다.
 * 각 ```BreadcrumbsItem```은 경로를 나타내며, 클릭 시 해당 경로로 이동합니다.
 */
export default function Breadcrumbs({ children }: BreadcumbsProps) {
  return (
    <div className={styles.breadcrumbs}>
      {Array.isArray(children)
        ? children.map((child, idx) => (
          (!!child &&
            <Fragment key={idx}>
              {idx > 0 && (
                <div className={styles.separator}>
                  {'>'}
                </div>
              )}
              {child}
            </Fragment>)
        ))
        : children}
    </div>
  );
}

interface BreadcrumbsItemProps {
  /**
   * BreadcrumbsItem의 자식 요소로 표시될 텍스트입니다.
   * 경로를 나타내며, 클릭 시 해당 경로로 이동합니다.
   */
  children: React.ReactNode;
  /**
   * BreadcrumbsItem이 클릭되었을 때 이동할 경로입니다.
   * 기본값은 '/'로 설정되어 있습니다.
   *
   */
  path: string;
  /**
   * BreadcrumbsItem이 홈 아이콘을 표시할지 여부입니다.
   * 기본값은 false로 설정되어 있습니다.
   * true로 설정하면 홈 아이콘이 표시됩니다.
   */
  root?: boolean;
}

/**
 * BreadcrumbsItem 컴포넌트
 * Breadcrumbs 컴포넌트의 자식으로 사용되며, 경로를 나타냅니다.
 * 클릭 시 해당 경로로 이동합니다.
 * 기본적으로 홈 아이콘과 함께 표시됩니다.
 */
export function BreadcrumbsItem({ children, path, root }: BreadcrumbsItemProps) {
  return (
    <button
      className={styles.item}
      type="button"
      onClick={() => {
        window.location.assign(path);
      }}
    >
      {root
        ? (
          <>
            <HomeIcon className={styles.icon} />
            {children}
          </>
        )
        : children}
    </button>
  );
}